module.exports = __webpack_public_path__ + "static/media/nrg.259d3e51.svg";